import createError from 'http-errors';

export const invalidServerResponseHandler = (message, functions) => {
  functions.forEach((func) => func(message));
  throw new Error(message);
};
